import { useLocalVariant } from "@draftkings/arena-web";
import * as React from "react";
import { LoadingBetCard } from "../BetCards";
export const LoadingBetsScreen = React.memo(function LoadingBetsScreen(props) {
    const { loadingBetCardsCount } = props;
    const loadingLineVariant = useLocalVariant("layout", {
        root: {
            borderRadius: "2px",
            backgroundColor: "$gray700",
            opacity: 0.7,
            maxWidth: "100%",
        }
    });
    const cards = Array.from({ length: loadingBetCardsCount });
    return (React.createElement(React.Fragment, null, cards.map((_, index) => React.createElement(LoadingBetCard, { key: `loading-card-${index}`, loadingLineVariant: loadingLineVariant }))));
});
//# sourceMappingURL=LoadingBetsScreen.js.map